var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.788.808a1.4 1.4 0 0 0-1.98 1.98l3.21 3.21-3.21 3.21a1.4 1.4 0 1 0 1.98 1.98l3.21-3.21 3.21 3.21a1.4 1.4 0 1 0 1.98-1.98l-3.21-3.21 3.21-3.21a1.4 1.4 0 0 0-1.98-1.98l-3.21 3.21-3.21-3.21z", fill: "#fff" })
  );
});